import { render } from "./CreateAccount.vue?vue&type=template&id=6dc2c52b&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=6dc2c52b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dc2c52b"

export default script